// @generated by protobuf-ts 2.9.0 with parameter generate_dependencies,force_optimize_code_size,long_type_string,ts_nocheck
// @generated from protobuf file "robotreservation/v1/robot_reservation.proto" (package "robotreservation.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
//
// Viam rover rentals
//
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { RobotReservationService } from "./robot_reservation";
import type { GetActiveRobotReservationResponse } from "./robot_reservation";
import type { GetActiveRobotReservationRequest } from "./robot_reservation";
import type { ListAllRobotReservationsResponse } from "./robot_reservation";
import type { ListAllRobotReservationsRequest } from "./robot_reservation";
import type { GetReservationCountsResponse } from "./robot_reservation";
import type { GetReservationCountsRequest } from "./robot_reservation";
import type { UpdateProcessStateResponse } from "./robot_reservation";
import type { UpdateProcessStateRequest } from "./robot_reservation";
import type { TryProcessResponse } from "./robot_reservation";
import type { TryProcessRequest } from "./robot_reservation";
import type { ListRoverAgentsResponse } from "./robot_reservation";
import type { ListRoverAgentsRequest } from "./robot_reservation";
import type { DeleteRoverAgentResponse } from "./robot_reservation";
import type { DeleteRoverAgentRequest } from "./robot_reservation";
import type { CreateRoverAgentResponse } from "./robot_reservation";
import type { CreateRoverAgentRequest } from "./robot_reservation";
import type { UpdateRobotReservationPriorityResponse } from "./robot_reservation";
import type { UpdateRobotReservationPriorityRequest } from "./robot_reservation";
import type { ExtendRobotReservationResponse } from "./robot_reservation";
import type { ExtendRobotReservationRequest } from "./robot_reservation";
import type { GetRobotReservationResponse } from "./robot_reservation";
import type { GetRobotReservationRequest } from "./robot_reservation";
import type { ListRobotReservationsResponse } from "./robot_reservation";
import type { ListRobotReservationsRequest } from "./robot_reservation";
import type { DeleteRobotReservationResponse } from "./robot_reservation";
import type { DeleteRobotReservationRequest } from "./robot_reservation";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { CreateRobotReservationResponse } from "./robot_reservation";
import type { CreateRobotReservationRequest } from "./robot_reservation";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * RobotReservationService is used to create and manage robot reservations in a queue.
 * This service is in pre-beta and is not guaranteed to be backwards compatible.
 *
 * @generated from protobuf service robotreservation.v1.RobotReservationService
 */
export interface IRobotReservationServiceClient {
    /**
     * Create reservation
     *  - User is the user logged in
     *  - viam employees can add any user to the list.
     *
     * @generated from protobuf rpc: CreateRobotReservation(robotreservation.v1.CreateRobotReservationRequest) returns (robotreservation.v1.CreateRobotReservationResponse);
     */
    createRobotReservation(input: CreateRobotReservationRequest, options?: RpcOptions): UnaryCall<CreateRobotReservationRequest, CreateRobotReservationResponse>;
    /**
     * Delete reservation
     *  - Can delete reservation if logged in user the same as reservation
     *  - viam employees can remove anyones.
     *
     * @generated from protobuf rpc: DeleteRobotReservation(robotreservation.v1.DeleteRobotReservationRequest) returns (robotreservation.v1.DeleteRobotReservationResponse);
     */
    deleteRobotReservation(input: DeleteRobotReservationRequest, options?: RpcOptions): UnaryCall<DeleteRobotReservationRequest, DeleteRobotReservationResponse>;
    /**
     * List reservations
     *  - returns only active reservations for the current user.
     *  - this endpoint is deprecated, see GetActiveReservation
     *
     * @deprecated
     * @generated from protobuf rpc: ListRobotReservations(robotreservation.v1.ListRobotReservationsRequest) returns (robotreservation.v1.ListRobotReservationsResponse);
     */
    listRobotReservations(input: ListRobotReservationsRequest, options?: RpcOptions): UnaryCall<ListRobotReservationsRequest, ListRobotReservationsResponse>;
    /**
     * Get reservation
     *  - Can get reservation if logged in user the same as reservation
     *  - viam employees can get anyones.
     *
     * @generated from protobuf rpc: GetRobotReservation(robotreservation.v1.GetRobotReservationRequest) returns (robotreservation.v1.GetRobotReservationResponse);
     */
    getRobotReservation(input: GetRobotReservationRequest, options?: RpcOptions): UnaryCall<GetRobotReservationRequest, GetRobotReservationResponse>;
    /**
     * Extend Reservation
     *  - User is the user logged in
     *  - viam employees can add any user to the list.
     *
     * @generated from protobuf rpc: ExtendRobotReservation(robotreservation.v1.ExtendRobotReservationRequest) returns (robotreservation.v1.ExtendRobotReservationResponse);
     */
    extendRobotReservation(input: ExtendRobotReservationRequest, options?: RpcOptions): UnaryCall<ExtendRobotReservationRequest, ExtendRobotReservationResponse>;
    /**
     * Update Reservation Priority
     *  - User must be a viam employee
     *
     * @generated from protobuf rpc: UpdateRobotReservationPriority(robotreservation.v1.UpdateRobotReservationPriorityRequest) returns (robotreservation.v1.UpdateRobotReservationPriorityResponse);
     */
    updateRobotReservationPriority(input: UpdateRobotReservationPriorityRequest, options?: RpcOptions): UnaryCall<UpdateRobotReservationPriorityRequest, UpdateRobotReservationPriorityResponse>;
    /**
     * Create and register a rover agent.
     *  - Returns a key/config to provision the raspberry pi with.
     *
     * @generated from protobuf rpc: CreateRoverAgent(robotreservation.v1.CreateRoverAgentRequest) returns (robotreservation.v1.CreateRoverAgentResponse);
     */
    createRoverAgent(input: CreateRoverAgentRequest, options?: RpcOptions): UnaryCall<CreateRoverAgentRequest, CreateRoverAgentResponse>;
    /**
     * Deletes a rover agent.
     *
     * @generated from protobuf rpc: DeleteRoverAgent(robotreservation.v1.DeleteRoverAgentRequest) returns (robotreservation.v1.DeleteRoverAgentResponse);
     */
    deleteRoverAgent(input: DeleteRoverAgentRequest, options?: RpcOptions): UnaryCall<DeleteRoverAgentRequest, DeleteRoverAgentResponse>;
    /**
     * List rover agents.
     *
     * @generated from protobuf rpc: ListRoverAgents(robotreservation.v1.ListRoverAgentsRequest) returns (robotreservation.v1.ListRoverAgentsResponse);
     */
    listRoverAgents(input: ListRoverAgentsRequest, options?: RpcOptions): UnaryCall<ListRoverAgentsRequest, ListRoverAgentsResponse>;
    /**
     * Robot Board - attempt to process.
     *   - If queue is empty, return nothing and tell robot to sleep for X.
     *
     *   - If queue has item in it:
     *     - Find and update highest priority, oldest item.
     *     - Update with state:APP_PROVISIONING and metadata.
     *     - Start create/associating robot/part/org details. If failed state=FAILED
     *     - If completed update with APP_PROVISIONED.
     *     - Return details about the org. And tell robot to provision /etc/viam.json.
     * Notes:
     *  - Need to handle cases where state=APP_PROVISIONING but robot failed to update to WORKING. Next request
     *  by the same robot process should return the same queue item.
     *  - Need to handle cases where APP_PROVISIONING fails completely and stuck in state.
     *
     * @generated from protobuf rpc: TryProcess(robotreservation.v1.TryProcessRequest) returns (robotreservation.v1.TryProcessResponse);
     */
    tryProcess(input: TryProcessRequest, options?: RpcOptions): UnaryCall<TryProcessRequest, TryProcessResponse>;
    /**
     * Update the state to WORKING or FAILED when the robot is ready.
     *
     * @generated from protobuf rpc: UpdateProcessState(robotreservation.v1.UpdateProcessStateRequest) returns (robotreservation.v1.UpdateProcessStateResponse);
     */
    updateProcessState(input: UpdateProcessStateRequest, options?: RpcOptions): UnaryCall<UpdateProcessStateRequest, UpdateProcessStateResponse>;
    /**
     * Returns the total count of queued reservations
     *
     * @generated from protobuf rpc: GetReservationCounts(robotreservation.v1.GetReservationCountsRequest) returns (robotreservation.v1.GetReservationCountsResponse);
     */
    getReservationCounts(input: GetReservationCountsRequest, options?: RpcOptions): UnaryCall<GetReservationCountsRequest, GetReservationCountsResponse>;
    /**
     * List all reservations in the queue reservations with the given query
     *  - only viam employees can use this endpoint.
     *
     * @generated from protobuf rpc: ListAllRobotReservations(robotreservation.v1.ListAllRobotReservationsRequest) returns (robotreservation.v1.ListAllRobotReservationsResponse);
     */
    listAllRobotReservations(input: ListAllRobotReservationsRequest, options?: RpcOptions): UnaryCall<ListAllRobotReservationsRequest, ListAllRobotReservationsResponse>;
    /**
     * Get the active reservation for the current user, if one exists
     *
     * @generated from protobuf rpc: GetActiveRobotReservation(robotreservation.v1.GetActiveRobotReservationRequest) returns (robotreservation.v1.GetActiveRobotReservationResponse);
     */
    getActiveRobotReservation(input: GetActiveRobotReservationRequest, options?: RpcOptions): UnaryCall<GetActiveRobotReservationRequest, GetActiveRobotReservationResponse>;
}
/**
 * RobotReservationService is used to create and manage robot reservations in a queue.
 * This service is in pre-beta and is not guaranteed to be backwards compatible.
 *
 * @generated from protobuf service robotreservation.v1.RobotReservationService
 */
export class RobotReservationServiceClient implements IRobotReservationServiceClient, ServiceInfo {
    typeName = RobotReservationService.typeName;
    methods = RobotReservationService.methods;
    options = RobotReservationService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * Create reservation
     *  - User is the user logged in
     *  - viam employees can add any user to the list.
     *
     * @generated from protobuf rpc: CreateRobotReservation(robotreservation.v1.CreateRobotReservationRequest) returns (robotreservation.v1.CreateRobotReservationResponse);
     */
    createRobotReservation(input: CreateRobotReservationRequest, options?: RpcOptions): UnaryCall<CreateRobotReservationRequest, CreateRobotReservationResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<CreateRobotReservationRequest, CreateRobotReservationResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Delete reservation
     *  - Can delete reservation if logged in user the same as reservation
     *  - viam employees can remove anyones.
     *
     * @generated from protobuf rpc: DeleteRobotReservation(robotreservation.v1.DeleteRobotReservationRequest) returns (robotreservation.v1.DeleteRobotReservationResponse);
     */
    deleteRobotReservation(input: DeleteRobotReservationRequest, options?: RpcOptions): UnaryCall<DeleteRobotReservationRequest, DeleteRobotReservationResponse> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<DeleteRobotReservationRequest, DeleteRobotReservationResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * List reservations
     *  - returns only active reservations for the current user.
     *  - this endpoint is deprecated, see GetActiveReservation
     *
     * @deprecated
     * @generated from protobuf rpc: ListRobotReservations(robotreservation.v1.ListRobotReservationsRequest) returns (robotreservation.v1.ListRobotReservationsResponse);
     */
    listRobotReservations(input: ListRobotReservationsRequest, options?: RpcOptions): UnaryCall<ListRobotReservationsRequest, ListRobotReservationsResponse> {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListRobotReservationsRequest, ListRobotReservationsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Get reservation
     *  - Can get reservation if logged in user the same as reservation
     *  - viam employees can get anyones.
     *
     * @generated from protobuf rpc: GetRobotReservation(robotreservation.v1.GetRobotReservationRequest) returns (robotreservation.v1.GetRobotReservationResponse);
     */
    getRobotReservation(input: GetRobotReservationRequest, options?: RpcOptions): UnaryCall<GetRobotReservationRequest, GetRobotReservationResponse> {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetRobotReservationRequest, GetRobotReservationResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Extend Reservation
     *  - User is the user logged in
     *  - viam employees can add any user to the list.
     *
     * @generated from protobuf rpc: ExtendRobotReservation(robotreservation.v1.ExtendRobotReservationRequest) returns (robotreservation.v1.ExtendRobotReservationResponse);
     */
    extendRobotReservation(input: ExtendRobotReservationRequest, options?: RpcOptions): UnaryCall<ExtendRobotReservationRequest, ExtendRobotReservationResponse> {
        const method = this.methods[4], opt = this._transport.mergeOptions(options);
        return stackIntercept<ExtendRobotReservationRequest, ExtendRobotReservationResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Update Reservation Priority
     *  - User must be a viam employee
     *
     * @generated from protobuf rpc: UpdateRobotReservationPriority(robotreservation.v1.UpdateRobotReservationPriorityRequest) returns (robotreservation.v1.UpdateRobotReservationPriorityResponse);
     */
    updateRobotReservationPriority(input: UpdateRobotReservationPriorityRequest, options?: RpcOptions): UnaryCall<UpdateRobotReservationPriorityRequest, UpdateRobotReservationPriorityResponse> {
        const method = this.methods[5], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateRobotReservationPriorityRequest, UpdateRobotReservationPriorityResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Create and register a rover agent.
     *  - Returns a key/config to provision the raspberry pi with.
     *
     * @generated from protobuf rpc: CreateRoverAgent(robotreservation.v1.CreateRoverAgentRequest) returns (robotreservation.v1.CreateRoverAgentResponse);
     */
    createRoverAgent(input: CreateRoverAgentRequest, options?: RpcOptions): UnaryCall<CreateRoverAgentRequest, CreateRoverAgentResponse> {
        const method = this.methods[6], opt = this._transport.mergeOptions(options);
        return stackIntercept<CreateRoverAgentRequest, CreateRoverAgentResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Deletes a rover agent.
     *
     * @generated from protobuf rpc: DeleteRoverAgent(robotreservation.v1.DeleteRoverAgentRequest) returns (robotreservation.v1.DeleteRoverAgentResponse);
     */
    deleteRoverAgent(input: DeleteRoverAgentRequest, options?: RpcOptions): UnaryCall<DeleteRoverAgentRequest, DeleteRoverAgentResponse> {
        const method = this.methods[7], opt = this._transport.mergeOptions(options);
        return stackIntercept<DeleteRoverAgentRequest, DeleteRoverAgentResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * List rover agents.
     *
     * @generated from protobuf rpc: ListRoverAgents(robotreservation.v1.ListRoverAgentsRequest) returns (robotreservation.v1.ListRoverAgentsResponse);
     */
    listRoverAgents(input: ListRoverAgentsRequest, options?: RpcOptions): UnaryCall<ListRoverAgentsRequest, ListRoverAgentsResponse> {
        const method = this.methods[8], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListRoverAgentsRequest, ListRoverAgentsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Robot Board - attempt to process.
     *   - If queue is empty, return nothing and tell robot to sleep for X.
     *
     *   - If queue has item in it:
     *     - Find and update highest priority, oldest item.
     *     - Update with state:APP_PROVISIONING and metadata.
     *     - Start create/associating robot/part/org details. If failed state=FAILED
     *     - If completed update with APP_PROVISIONED.
     *     - Return details about the org. And tell robot to provision /etc/viam.json.
     * Notes:
     *  - Need to handle cases where state=APP_PROVISIONING but robot failed to update to WORKING. Next request
     *  by the same robot process should return the same queue item.
     *  - Need to handle cases where APP_PROVISIONING fails completely and stuck in state.
     *
     * @generated from protobuf rpc: TryProcess(robotreservation.v1.TryProcessRequest) returns (robotreservation.v1.TryProcessResponse);
     */
    tryProcess(input: TryProcessRequest, options?: RpcOptions): UnaryCall<TryProcessRequest, TryProcessResponse> {
        const method = this.methods[9], opt = this._transport.mergeOptions(options);
        return stackIntercept<TryProcessRequest, TryProcessResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Update the state to WORKING or FAILED when the robot is ready.
     *
     * @generated from protobuf rpc: UpdateProcessState(robotreservation.v1.UpdateProcessStateRequest) returns (robotreservation.v1.UpdateProcessStateResponse);
     */
    updateProcessState(input: UpdateProcessStateRequest, options?: RpcOptions): UnaryCall<UpdateProcessStateRequest, UpdateProcessStateResponse> {
        const method = this.methods[10], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateProcessStateRequest, UpdateProcessStateResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Returns the total count of queued reservations
     *
     * @generated from protobuf rpc: GetReservationCounts(robotreservation.v1.GetReservationCountsRequest) returns (robotreservation.v1.GetReservationCountsResponse);
     */
    getReservationCounts(input: GetReservationCountsRequest, options?: RpcOptions): UnaryCall<GetReservationCountsRequest, GetReservationCountsResponse> {
        const method = this.methods[11], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetReservationCountsRequest, GetReservationCountsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * List all reservations in the queue reservations with the given query
     *  - only viam employees can use this endpoint.
     *
     * @generated from protobuf rpc: ListAllRobotReservations(robotreservation.v1.ListAllRobotReservationsRequest) returns (robotreservation.v1.ListAllRobotReservationsResponse);
     */
    listAllRobotReservations(input: ListAllRobotReservationsRequest, options?: RpcOptions): UnaryCall<ListAllRobotReservationsRequest, ListAllRobotReservationsResponse> {
        const method = this.methods[12], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListAllRobotReservationsRequest, ListAllRobotReservationsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Get the active reservation for the current user, if one exists
     *
     * @generated from protobuf rpc: GetActiveRobotReservation(robotreservation.v1.GetActiveRobotReservationRequest) returns (robotreservation.v1.GetActiveRobotReservationResponse);
     */
    getActiveRobotReservation(input: GetActiveRobotReservationRequest, options?: RpcOptions): UnaryCall<GetActiveRobotReservationRequest, GetActiveRobotReservationResponse> {
        const method = this.methods[13], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetActiveRobotReservationRequest, GetActiveRobotReservationResponse>("unary", this._transport, method, opt, input);
    }
}
